'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M16.773 4.972a.34.34 0 0 1 .34.34V20.82c0 .187-.153.34-.34.34H7.34a.34.34 0 0 1-.34-.34V5.312a.34.34 0 0 1 .34-.34Zm-.34.68H7.68V20.48h1.405v-3.465c0-.125.102-.226.227-.226h2.039c.125 0 .226.101.226.226v3.465h4.856V5.651Zm-5.31 11.59H9.539v3.238h1.586v-3.238ZM17.113 3.16v.68H7v-.68h10.112Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.801 16.789c.125 0 .226.101.226.227v2.038a.226.226 0 0 1-.226.227h-2.039a.227.227 0 0 1-.227-.227v-2.038c0-.126.102-.227.227-.227h2.039Zm-.227.453h-1.586v1.586h1.586v-1.586Zm.227-3.903c.125 0 .226.101.226.227v2.038a.227.227 0 0 1-.226.227h-2.039a.227.227 0 0 1-.227-.227v-2.038c0-.126.102-.227.227-.227h2.039Zm-3.45 0c.125 0 .226.101.226.227v2.038a.227.227 0 0 1-.226.227H9.312a.227.227 0 0 1-.227-.227v-2.038c0-.126.102-.227.227-.227h2.039Zm3.223.453h-1.586v1.586h1.586v-1.586Zm-3.45 0H9.538v1.586h1.586v-1.586Zm3.677-3.903c.125 0 .226.101.226.226v2.039a.227.227 0 0 1-.226.227h-2.039a.227.227 0 0 1-.227-.227v-2.039c0-.125.102-.226.227-.226h2.039Zm-3.45 0c.125 0 .226.101.226.226v2.039a.227.227 0 0 1-.226.227H9.312a.227.227 0 0 1-.227-.227v-2.039c0-.125.102-.226.227-.226h2.039Zm3.223.453h-1.586v1.586h1.586v-1.586Zm-3.45 0H9.538v1.586h1.586v-1.586Zm3.677-3.904c.125 0 .226.102.226.227v2.039a.226.226 0 0 1-.226.226h-2.039a.227.227 0 0 1-.227-.226V6.665c0-.125.102-.227.227-.227h2.039Zm-3.45 0c.125 0 .226.102.226.227v2.039a.226.226 0 0 1-.226.226H9.312a.227.227 0 0 1-.227-.226V6.665c0-.125.102-.227.227-.227h2.039Zm3.223.453h-1.586v1.586h1.586V6.891Zm-3.45 0H9.538v1.586h1.586V6.891Z",
    fill: "currentColor"
  })));
});
var FwSet0Levelplus = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Levelplus = FwSet0Levelplus;